import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import "./MobileEntry.css";
import axios from "axios";
import process from "process";
require("dotenv").config();

const packArray = [
  // { plan: "DAILY", pack: "MASTERCARD_IDENTITY_THEFT_PROTECTION" },
  { plan: "MONTHLY", pack: "URDUFLIX" },
];

const MobileEntry = (props) => {
  const [showError, setShowError] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const [pinEntered, setPinEntered] = useState(new Array(4).fill(""));
  const [otpError, setOtpError] = useState(null);
  const otpBoxReference = useRef([]);

  const [showPin, setShowPin] = useState(false);
  const [otpTimer, setOtpTimer] = useState(10000);
  const [showResend, setShowResend] = useState(false);

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [otpButtonDisabled, setOtpButtonDisabled] = useState(true);
  const [checked, setChecked] = useState(false);

  const otpContainerRef = useRef(null);

  useEffect(() => {
    let otpTimerInterval;
    if (otpTimer > 0) {
      otpTimerInterval = setInterval(() => {
        setOtpTimer((prev) => {
          return prev - 1;
        });
      }, 1000);
    }
    if (otpTimer === 0) {
      clearInterval(otpTimerInterval);
    }
  }, []);

  useEffect(() => {
    if (otpTimer === 0) {
      setShowResend(true);
    }
  }, [otpTimer]);

  useEffect(() => {
    if (otpContainerRef.current) {
      const inputs = otpContainerRef.current.querySelectorAll("input");
      inputs.forEach((input, index) => {
        input.addEventListener("input", (e) => {
          if (index === 3) {
            setOtpButtonDisabled(false);
          }
          if (index < inputs.length - 1) {
            inputs[index + 1].focus();
          }
        });
        input.addEventListener("keydown", (e) => {
          if (e.key === "Backspace" && index > 0) {
            e.preventDefault();
            e.target.value = "";
            inputs[index - 1].focus();
            if (index === 3) {
              setOtpButtonDisabled(true);
            }
          }
        });
      });
    }
  }, [otpContainerRef]);

  useEffect(() => {
    console.log("From MobileEntry > ", packArray[props.pack]);
  }, [props.pack]);


  const resourceKey = {
    subRequest: process.env.REACT_APP_SUBREQUEST_KEY,
    subConfirm: process.env.REACT_APP_SUBCONFIRM_KEY,
  };
  const navigate = useNavigate();
  const reqId = useRef(uuid());
  const purePhoneNumber = useRef("");

  const radioValue = useSelector((state) => state.radioButton.selectedValue);
//   useEffect(() => {
//     console.log(radioValue);
//   }, [radioValue]);
  const tokenStr = window.btoa(
    `${process.env.REACT_APP_AFF_USER}:${process.env.REACT_APP_AFF_PWD}`
  );

  const handleInputChange = (e) => {
    const regex = /^[0-9\b]+$/;
    // console.log(regex.test(e.target.value));
    if (e.target.value === "" || regex.test(e.target.value))
      setPhoneNumber(e.target.value);
  };

  function handlePinChange(value, index) {
    let newArr = [...pinEntered];
    newArr[index] = value;
    setPinEntered(newArr);

    if(value && index < 3){
      otpBoxReference.current[index + 1].focus()
    }
  }

  function handleBackspaceAndEnter(e, index) {
    if(e.key === "Backspace" && !e.target.value && index > 0){
      otpBoxReference.current[index - 1].focus()
    }
    if(e.key === "Enter" && e.target.value && index < 4-1){
      otpBoxReference.current[index + 1].focus()
    }
  }

  const handleChangeNumber = () => {
    setShowPin(false)
    props.handleShowChooseYourPlan()
  }

  
//   useEffect(() => { 
//     if(pinEntered.join("") !== "" && pinEntered.join("") !== correctOTP){
//       setOtpError("❌ Wrong OTP Please Check Again")
//     }else{
//       setOtpError(null)
//     } 
//    }, [otp]);

  useEffect(() => {
    if (phoneNumber.length === 9) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [phoneNumber]);

  const onSubmitHandler = () => {
    const regex = /^((\+|00)?971)(5)\d{8}$/;

    purePhoneNumber.current = "971" + phoneNumber;

    if (purePhoneNumber.current.length !== 12) {
      setShowError("Please enter a valid mobile number");
      return false;
    }

    if (!regex.test(purePhoneNumber.current)) {
      setShowError("Phone number is invalid. Please enter a valid number");
      return false;
    }

    // const subRequestUrl = "/provider/api/subRequest";
    const subRequestUrl = "/provider/api/subRequest";
    // const subRequestUrl: string = "http://localhost:3000/subRequestFailGenErr";

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Basic " + tokenStr,
      correlatorId: reqId.current,
      ResourceKey: resourceKey.subRequest,
    };
    console.log("headers", headers);
    const config = {
      url: subRequestUrl,
      method: "POST",
      headers: headers,
      data: {
        source: "APP_MARKETPLACE",
        packName: packArray[props.pack].pack,
        planName: packArray[props.pack].plan,
        userId: purePhoneNumber.current,
        campaignId: process.env.REACT_APP_CAMPAIGN_ID,
        extendedParameters: { lpId: 20 },
        providerName: "ETISALAT_UAE",
        providerType: "TELECO",
      },
    };
    console.log("config", config);
    axios
      .request(config)
      .then(function (response) {
        let subRequestResponse = response.data;
        setShowPin(false);
        if (subRequestResponse.code === "SUCCESS") {
          if (typeof subRequestResponse.redirectURL != "undefined")
            window.location.replace(String(subRequestResponse.redirectURL));

          if (subRequestResponse.nextActions?.includes("SUB-CONFIRM"))
            setShowPin(true);
            props.handleShowChooseYourPlan()
            setOtpTimer(60)
        }
      })

      .catch(function (error) {
        let subRequestError = error.response.data;
  
        // console.log("This is raw error", error);
        // console.log("This is in var", subRequestError);

        if (subRequestError === null) {
          setShowError("Unable to process request, contact support");
          <div className="error-message">{showError}</div>;

          return false;
        }

        if (subRequestError.code === "OTP_LIMIT_REACHED") {
          setShowError(
            "You have reached the OTP Limit. Please try again in 24 hours"
          );
          <div className="error-message"> {showError} </div>;
          return false;
        }
        
        if (subRequestError.code === "SUBSCRIPTION_ALREADY_EXIST") {
          // if ("1" == CONST_CONF.get("PRINT_LOG"))
            console.log("we should be redirecting here");

          if (typeof subRequestError.redirectURL != "undefined") {
            // window.location.replace(String(jsonRes.cgURL)) // OTP Page redirect, in case of antifraud
            // if ("1" == CONST_CONF.get("PRINT_LOG"))
              console.log("REDIRECTING TO redirectUrl ---->", subRequestError.redirectURL);
            navigate("./success", {
              replace: false,
              state: { id: subRequestError.redirectUrl },
            });
          } else {
            console.log("REDIRECTING TO default");
            navigate("./success", { replace: true }); 
          }
          
        }

        if (
          subRequestError.code === "INVALID_MSISDN" ||
          subRequestError.code === "GEN_ERR"
        ) {
          setShowError("Please enter a valid phone number");
          <div className="error-message">{showError}</div>;
          return false;
        }
      });
  };

  //subconfirm Request start
  const onPinSubmitHandler = () => {
    const otp = pinEntered.join('')
    console.log(otp)
    if (otp.length < 4) {
        setShowError(
            "Please enter the OTP"
          );
    }
    if (otp.length === 4) {
      const subConfirmUrl = "/provider/api/subConfirm";
      // const subConfirmUrl: string = "http://localhost:3000/subConfirmSuccess"

      const headers = {
        "Content-Type": "application/json",
        Authorization: "Basic " + tokenStr,
        correlatorId: reqId.current,
        ResourceKey: resourceKey.subConfirm,
      };

      const config = {
        url: subConfirmUrl,
        method: "POST",
        // method: "GET",
        headers: headers,
        data: {
          source: "APP_MARKETPLACE",
          packName: packArray[props.pack].pack,
          planName: packArray[props.pack].plan,
          userId: purePhoneNumber.current,
          campaignId: process.env.REACT_APP_CAMPAIGN_ID,
          extendedParameters: { lpId: 20 },
          providerName: "ETISALAT_UAE",
          providerType: "TELECO",
          otp: otp,
        },
      };
      axios
        .request(config)
        .then(function (response) {
          const subConfirmResponse = response.data;

          console.log("pin is sent, handling success");

          if (subConfirmResponse.code === "SUCCESS") {
            if (subConfirmResponse.redirectURL !== null) {
              console.log('CGURL FOUND, it is', subConfirmResponse.redirectURL)
              navigate("./success", {
                replace: false,
                state: { id: subConfirmResponse.redirectURL },
              });
            } else navigate("./success", { replace: false });

            // setShowCongrats(true);
          }
          // if ("1" == CONST_CONF.get("PRINT_LOG")) console.log(jsonRes);
        })
        .catch(function (error) {
          let subConfirmError = error.response.data;

          console.log("pin is sent, handling fail");
          // if (subConfirmError.code === "SUBSCRIPTION_ALREADY_EXIST") { //TODO: Add GTM flags for sub already exist if needed
          //   if (subConfirmError.redirectURL !== null) {
          //     console.log('CGURL FOUND, it is', subConfirmError.redirectURL)
          //     navigate("./success", { replace: false, state: {id: subConfirmError.redirectURL}} );
          //   }
          // }

          if (subConfirmError === null) {
            setShowError(
              "Unable to Process Request , Kindly Contact System support."
            );

            <div className="error-message">{showError}</div>;
            return false;
          } else {
            if (subConfirmError.code === "GEN_ERR") {
              setShowError(
                "Invalid request / expired , Please refresh and resend request."
              );
              <div className="error-message">{showError}</div>;
              //console.log("------");
            }

            if (subConfirmError.code === "INVALID_MSISDN") {
              setShowError("Please enter a valid Mobile Number.");
              <div className="error-message">{showError}</div>;
            }

            if (subConfirmError.code === "OTP_NOT_VALID") {
              setShowError("Wrong PING entered");
              <div className="error-message">{showError}</div>;
            }
            if (subConfirmError.code === "OTP_NOT_VALID") {
              setShowError("Wrong OTP entered.");
              <div className="error-message">{showError}</div>;
            }

            if (subConfirmError.code === "SUBSCRIPTION_ALREADY_EXIST") {
              if (typeof subConfirmError.redirectURL != "undefined") {
                // window.location.replace(String(jsonRes.cgURL)) // OTP Page redirect, in case of antifraud
                // if ("1" == CONST_CONF.get("PRINT_LOG"))
                //   console.log("REDIRECTING TO SOMETHING");
                navigate("./success", {
                  replace: false,
                  state: { id: subConfirmError.redirectUrl },
                });
              }
              navigate("./success", { replace: true }); //TODO redirect page
            }

            //MySwal.fire(<p>{jsonRes.errordesc}</p>);
          }
        });

     
    }
  };
  //subconfirm Request end

  return (
    <div className="etisalatMob_section">
      {!showPin && (
        <div className="entermob_section">
          <div className="entermob-title">
            <div className="error-message">{showError}</div>
            <h4>Enter your Etisalat Mobile Number</h4>
            {/* <div className="error">{showError}</div> */}
          </div>
          <div className="form-group mobnumsec">
            {/* <label className="input-title" htmlFor="mobnum">
              Mobile Number
            </label> */}

            <div className="d-flex mobnum_wrp">
              <input
                type="text"
                className="form-control mobCode"
                placeholder="+971"
                name="prefix"
                value=""
                // style={{pointer -events: none; border-bottom: 1px solid rgb(115, 116, 117);}}
              />

              <div className="d-flex mobNum msisdn-entry">
                <input
                  type="tel"
                  className="form-control"
                  placeholder="XXXXXXXXX"
                  maxLength="9"
                  name="msisdn"
                  inputMode="decimal"
                  value={phoneNumber}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                  // style={{border -bottom: 1px solid rgb(115, 116, 117);}}
                />
              </div>
            </div>
          </div>

          <div className="form-group d-flex terms">
            <label className="radio_paymentType mob_termsCheckbox">
              <div className="checkbox-container">
                <input
                  value="117"
                  type="checkbox"
                  id="termsCheckbox"
                  name="termsRadio"
                  onChange={(e) => {
                    setChecked(e.target.checked);
                  }}
                />
                <span className="custom-checkbox"></span>
              </div>
              <div>
                I have read all the terms and conditions forming part of the
                entire contractual arrangement between Etisalat and the Customer
                and I agree to the same.
              </div>
            </label>
          </div>

          <div className="form-group sendotpBtn">
            <div className="form-group sendotpBtn">
              <button
                className="btn btn-black send-pin-btn"
                // className={isButtonDisabled || !checked ? "send-pin-btn" : "send-pin-btn-disabled"}
                disabled={isButtonDisabled || !checked}
                onClick={onSubmitHandler}
              >
                Send PIN
              </button>
            </div>
          </div>
        </div>
      )}

      {showPin && (
        <>
          <p>
            Please enter the 4-digit verification code sent to your mobile
            number 0{phoneNumber}
          </p>
          <div className="error-message">{showError}</div>

          <button className="change-num-link" onClick={handleChangeNumber}>Change Number</button>
          <div className="otp-input-container" ref={otpContainerRef}>
            {/* <input type="text" maxLength={1} />
            <input type="text" maxLength={1} />
            <input type="text" maxLength={1} />
            <input type="text" maxLength={1} /> */}

            {pinEntered.map((digit, index) => (
              <input
                type="text"
                key={index}
                value={digit}
                maxLength={1}
                onChange={(e) => handlePinChange(e.target.value, index)}
                onKeyUp={(e) => handleBackspaceAndEnter(e, index)}
                ref={(reference) =>
                  (otpBoxReference.current[index] = reference)
                }
                // className={`border w-20 h-auto text-white p-3 rounded-md block bg-black focus:border-2 focus:outline-none appearance-none`}
              />
            ))}
          </div>
          <div className="form-group sendotpBtn">
            <button
              onClick={onPinSubmitHandler}
              className="btn btn-black send-otppin-btn"
            >
              Confirm
            </button>
          </div>
          {!showResend && <p>Resend in {otpTimer} seconds</p>}
          {showResend && (
            <p>
              Didn't receive the code?{" "}
              <button className="resend-link change-num-link" onClick={onSubmitHandler}>Resend code</button>
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default MobileEntry;
